module.exports = __webpack_public_path__ + "img/mail.728c1375.svg";